export const NAVIGATION_START = "NAVIGATION_START";
export const NAVIGATION_END = "NAVIGATION_END";
